import Config from "../constants/Configuration";

if (!Config.Api) {
  throw new Error("Failed to load api connection details from local configuration");
}

export default {
  host: Config.Api.host,
  imageCDN: Config.Api.imageCDN,
};



// WEBPACK FOOTER //
// ./routes/Host.js